import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { FaEdit, FaTrash, FaEye } from 'react-icons/fa';
import { FaPlus } from 'react-icons/fa6';
import DatePicker from 'react-datepicker';
import Modal from 'react-bootstrap/Modal';
import 'react-datepicker/dist/react-datepicker.css';
import { canViewCustomerDocument, isCustomerDocumentImage, resolveCustomerDocumentUrl } from './customerDocumentHelpers';

const DocumentDetails = ({ setDocumentsList, documentsList, documentType, readOnly = false }) => {
  const initialState = {
    type: null,
    IssueDate: null,
    documentNo: '',
    file: null,
    expiryDate: null,
    Remarks: '',
    verified: false,
  };

  const [formData, setFormData] = useState(initialState);
  const [editIndex, setEditIndex] = useState(null);
  const [previewModal, setPreviewModal] = useState(false);
  const [previewUrl, setPreviewUrl] = useState('');
  const [previewIsBlob, setPreviewIsBlob] = useState(false);

  useEffect(() => {
    return () => {
      if (previewIsBlob && previewUrl) {
        URL.revokeObjectURL(previewUrl);
      }
    };
  }, [previewIsBlob, previewUrl]);

  const closePreview = () => {
    if (previewIsBlob && previewUrl) {
      URL.revokeObjectURL(previewUrl);
    }
    setPreviewModal(false);
    setPreviewUrl('');
    setPreviewIsBlob(false);
  };

  const handleInputChange = (e) => {
    const { name, value, files } = e.target;
    if (name === 'file') {
      setFormData((prev) => ({ ...prev, file: files[0] }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSelectChange = (selected) => {
    setFormData((prev) => ({ ...prev, type: selected }));
  };
  const handleDateChange = (input) => {
    const value = input?.target?.value || input.value;
    const name = input?.target?.name || input.name;
    const updatedValue = typeof value === 'string' ? value : formatDate(value);
    setFormData((prev) => ({ ...prev, [name]: updatedValue }));
  };

  const handleAddOrUpdate = () => {
    if (editIndex !== null) {
      const updated = [...documentsList];
      updated[editIndex] = formData;
      setDocumentsList(updated);
      setEditIndex(null);
    } else {
      setDocumentsList((prev) => [...prev, formData]);
    }

    setFormData(initialState);
  };

  const handleEdit = (index) => {
    setFormData({
      ...documentsList[index],
      file: null, // file input cannot be prefilled
    });
    setEditIndex(index);
  };

  const handleDelete = (index) => {
    setDocumentsList(documentsList.filter((_, i) => i !== index));
  };

  const handleView = (data) => {
    const url = resolveCustomerDocumentUrl(data);
    if (!url) return;

    if (isCustomerDocumentImage(data, url)) {
      setPreviewUrl(url);
      setPreviewIsBlob(data?.file instanceof File);
      setPreviewModal(true);
      return;
    }

    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const formatDate = (date) => {
    if (!date || date === '0') return '--';
    const parsed = new Date(date);
    if (Number.isNaN(parsed.getTime()) || parsed.getFullYear() <= 1900) return '--';
    return parsed.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    });
  };

  return (
    <div className="cost-center-section my-3">
      <div className="border-box2 p-3" style={{ borderRadius: '8px' }}>
        {!readOnly && (
          <>
            <div className="form-group grid-contain ">
              <div className="d-flex gap-3">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="taxInclusive"
                  style={{ width: '20px', height: '20px' }}
                  checked={formData.verified}
                  onChange={(e) => setFormData((prev) => ({ ...prev, verified: e.target.checked }))}
                />
                <label className="form-check-label" htmlFor="taxInclusive">
                  Document Verified
                </label>
              </div>
              <div></div>
              <div></div>

              <div className="d-flex">
                <label className="form-label pt-1 start">Document Type</label>
                <Select
                  className="p-0 w-100"
                  menuPortalTarget={document.body}
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: 5,
                    padding: 9,
                  })}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    option: (provided, state) => ({
                      ...provided,
                      backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                      color: state.isFocused ? '#000 ' : '#000',
                      ':hover': {
                        backgroundColor: '#F5F5F5',
                        color: '#000 ',
                      },
                    }),
                  }}
                  onChange={handleSelectChange}
                  options={documentType?.map((country) => ({ value: country?.value, label: country?.text }))}
                  value={formData.type}
                />
              </div>

              <div className="d-flex">
                <label className="form-label pt-1 start">Issue Date </label>
                <DatePicker
                  selected={formData.IssueDate}
                  onChange={(date) => handleDateChange({ name: 'IssueDate', value: date })}
                  dateFormat="dd-MMM-yyyy"
                  className="p-2 form-control w-100"
                />
              </div>

              <div className="d-flex">
                <label className="form-label pt-1 start">Document No </label>
                <input type="text" className="p-2 form-control w-75" name="documentNo" value={formData.documentNo} onChange={handleInputChange} />
              </div>

              <div className="d-flex">
                <label className="form-label pt-1 start">File</label>
                <input type="file" className="p-2 form-control w-75" name="file" onChange={handleInputChange} />
              </div>

              <div className="d-flex">
                <label className="form-label pt-1 start">Expiry Date </label>
                <DatePicker
                  selected={formData.expiryDate}
                  onChange={(date) => handleDateChange({ name: 'expiryDate', value: date })}
                  dateFormat="dd-MMM-yyyy"
                  className="p-2 form-control w-100"
                />
              </div>

              <div className="d-flex">
                <label className="form-label pt-1 start">Remarks</label>
                <input type="text" className="p-2 form-control w-75" name="Remarks" value={formData.Remarks} onChange={handleInputChange} />
              </div>
            </div>

            <div className="my-4">
              <div className="mainbtnSecondary flex-end gap-2 col-2" onClick={handleAddOrUpdate}>
                <FaPlus color="#fff" className="center mt-1 mx-2" />
                <div className="center">{editIndex !== null ? 'Update File' : 'Add File'}</div>
              </div>
            </div>
          </>
        )}

        <div className="table-container" style={{ overflowX: 'auto', height: '400px' }}>
          <table className="table table-bordered gridshad">
            <thead className="dynoTable">
              <tr>
                <th>Document Type</th>
                <th>Document No</th>
                <th>Expiry Date</th>
                <th>Issue Date</th>
                <th>Remarks</th>
                <th style={{ minWidth: '110px', textAlign: 'center' }}>View</th>
                {!readOnly && <th style={{ minWidth: '90px', textAlign: 'center' }}>Action</th>}
              </tr>
            </thead>
            <tbody>
              {documentsList.map((data, index) => (
                <tr key={index}>
                  <td>{data.type?.label}</td>
                  <td>{data.documentNo}</td>
                  <td>{formatDate(data.expiryDate)}</td>
                  <td>{formatDate(data.IssueDate)}</td>
                  <td>{data.Remarks}</td>
                  <td className="align-middle text-center" style={{ minWidth: '110px' }}>
                    <div
                      className={`mainbtnRed flex-end gap-2 mx-auto ${canViewCustomerDocument(data) ? '' : 'opacity-50 pe-none'}`}
                      style={{ width: 'fit-content', minWidth: '88px', cursor: canViewCustomerDocument(data) ? 'pointer' : 'not-allowed' }}
                      onClick={() => canViewCustomerDocument(data) && handleView(data)}
                      role="button"
                      tabIndex={0}
                      onKeyDown={(e) => {
                        if (canViewCustomerDocument(data) && (e.key === 'Enter' || e.key === ' ')) {
                          e.preventDefault();
                          handleView(data);
                        }
                      }}
                    >
                      <FaEye color="#fff" className="center mt-1 mx-2" />
                      <div className="center">View</div>
                    </div>
                  </td>
                  {!readOnly && (
                    <td className="align-middle text-center" style={{ minWidth: '90px' }}>
                      <div className="d-flex justify-content-center align-items-center gap-3">
                        <FaEdit size={20} onClick={() => handleEdit(index)} style={{ cursor: 'pointer' }} title="Edit" />
                        <FaTrash size={20} color="red" onClick={() => handleDelete(index)} style={{ cursor: 'pointer' }} title="Delete" />
                      </div>
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <Modal show={previewModal} size="lg" onHide={closePreview}>
        <Modal.Header closeButton>
          <Modal.Title>Document Preview</Modal.Title>
        </Modal.Header>
        <Modal.Body>{previewUrl && <img src={previewUrl} alt="Document preview" style={{ width: '100%' }} />}</Modal.Body>
      </Modal>
    </div>
  );
};

export default DocumentDetails;
